import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-6 py-10 text-slate-900">
      <div className="flex min-h-[calc(100vh-5rem)] flex-col items-center justify-center text-center">
        <img
          src="/Group%202.svg"
          alt="Page not found"
          className="w-full max-w-[360px]"
        />
        <h1 className="mt-6 text-2xl font-semibold">Page not Found</h1>
        <p className="mt-2 text-sm text-slate-500">
          Looks like you're lost. Let's get you back to somewhere familiar
        </p>
        <button
          type="button"
          className="mt-4 rounded-[10px] bg-slate-900 px-4 py-2 text-xs font-semibold text-white"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFound;
